import { User } from "./user";

export class UserAccount {
    orgId: any;
    email: any;
    isDefault: any;
    accountId: any;
    isActive: any;
    fkUserId: User = new User();
}
